<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">VCNS Approval</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  
  <!-- Need Generation Data View (Readonly) -->
  <form [formGroup]="needGenForm" class="proposal-form-container mb-4">
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
      <div (click)="expandedSections['mainExpansion'] = !expandedSections['mainExpansion']"
           class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold flex items-center">
          <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
            <i class="pi pi-list"></i>
          </span>
          Need Generation Data  <span class="text-sm text-gray-500 bg-purple-100 text-purple-600 px-2 py-1 rounded ml-3">view</span>
        </h3>
        <i class="pi transition-transform duration-200"
           [ngClass]="expandedSections['mainExpansion'] ? 'pi-chevron-down' : 'pi-chevron-right'">
        </i>
      </div>
      <div *ngIf="expandedSections['mainExpansion']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
        <div class="form-container">
          <!-- Basic Information Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['basicInfo'] = !expandedSections['basicInfo']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-info-circle"></i>
                </span>
                Basic Information
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['basicInfo']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="form-grid">
                <div class="form-field full-width">
                  <label for="nomenclature">Nomenclature</label>
                  <input pInputText id="nomenclature" formControlName="nomenclature" [readonly]="true" class="readonly-input" />
                </div>
                
              </div>
              <div class="form-grid mt-3" *ngIf="schemeType == 'rev'">
                <div class="form-field">
                  <label for="platform">For which Platform</label>
                  <input pInputText id="platform" formControlName="platform" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field">
                  <label for="tenderMode">Mode of Tender</label>
                  <input pInputText id="tenderMode" formControlName="tenderMode" [readonly]="true" class="readonly-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Brief Description / Information Section (Make schemes) -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="isMakeScheme">
            <div (click)="expandedSections['information'] = !expandedSections['information']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-file"></i>
                </span>
                {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '2. Brief Description' : '2. Brief Description / How Is The Requirement Being Met Presently' }}
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['information'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['information']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '2.1 Name of the equipment/system/spare and where fitted' : '2.1 Brief Description With Technical Details.' }}
                </p>
                <editor [init]="previousInit" formControlName="brief_description" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'makeiii' && isMakeScheme">
                <p class="bg-blue-500 p-2 text-white font-medium">2.2 How Is The Requirement Being Met Presently</p>
                <editor [init]="previousInit" formControlName="requirement_met" [disabled]="true"></editor>
              </div>
            </div>
          </div>

          <!-- Dual Use Technology (Make I only) -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="schemeType === 'makeI'">
            <div class="p-4 bg-gray-100/90">
              <div class="form-grid">
                <div class="form-field">
                  <label>3. Dual Use Technology</label>
                  <input pInputText [value]="needGenForm.get('dualUseTechnology')?.value === true ? 'Yes' : 'No'" [readonly]="true" class="readonly-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Equipment & System Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
            <div (click)="expandedSections['equipment'] = !expandedSections['equipment']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-cog"></i>
                </span>
                Equipment & System
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['equipment'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['equipment']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="form-grid">
                <div class="form-field">
                  <label>Equipment</label>
                  <input pInputText formControlName="equipment" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field">
                  <label>System</label>
                  <input pInputText formControlName="system" [readonly]="true" class="readonly-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Quantity Details Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['quantity'] = !expandedSections['quantity']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-list"></i>
                </span>
                {{ schemeType === 'rev' ? 'Quantity Details' : (schemeType === 'makeI' ? '4. Quantity Required' : '3. Quantity Required') }}
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['quantity'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['quantity']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="form-grid">
                <div  class="form-field" *ngIf="schemeType === 'rev'">
                  <!-- <label>{{ schemeType === 'rev' ? 'Quantity Required' : 'Total Quantity Required' }}</label> -->
                   <label>Quantity Required</label>
                  <input pInputText formControlName="qtyReqd" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field">
                  <label>{{ (schemeType === 'makeII' || stepDetails?.step_mapping?.scheme?.code === 'makeiii') ? '3.1 Quantity Prototype' : (schemeType === 'makeI' ? '4.1 Quantity Prototype' : 'Quantity Prototype') }}</label>
                  <input pInputText formControlName="qtyPrototype" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field">
                  <label>{{ (schemeType === 'makeII' || stepDetails?.step_mapping?.scheme?.code === 'makeiii') ? '3.2 Quantity Bulk (MoQ)' : (schemeType === 'makeI' ? '4.2 Quantity Bulk (MoQ)' : 'Quantity Bulk (MoQ)') }}</label>
                  <input pInputText formControlName="qtyBulk" [readonly]="true" class="readonly-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Cost Details Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['cost'] = !expandedSections['cost']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-dollar"></i>
                </span>
                {{ schemeType === 'rev' ? 'Cost Details' : (schemeType === 'makeI' ? '5. Estimated Cost' : '4. Estimated Cost') }}
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['cost'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['cost']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="form-grid">
                <div class="form-field">
                  <label>{{ schemeType === 'rev' ? 'Estimated Total Cost (in INR)' : (schemeType === 'makeI' ? '5.1 For Development Of Prototype' : '4.1 For Development Of Prototype') }}</label>
                  <input pInputText formControlName="estimatedDevelopmentCost" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field">
                  <label>{{ schemeType === 'rev' ? 'Estimated Unit Cost' : (schemeType === 'makeI' ? '5.2 Unit Cost For Bulk Quantity(in INR)' : '4.2 Unit Cost For Bulk Quantity(in INR)') }}</label>
                  <input pInputText formControlName="estimatedUnitCost" [readonly]="true" class="readonly-input" />
                </div>
                <!-- Basis of Estimated Cost heading (Make schemes) -->
                <div class="form-field full-width" *ngIf="isMakeScheme">
                  <label class="font-bold">{{ (schemeType === 'makeII' || stepDetails?.step_mapping?.scheme?.code === 'makeiii') ? '4.3' : '5.3' }}. Basis of Estimated Cost</label>
                </div>
                <!-- Make I detailed sub-fields -->
                <ng-container *ngIf="schemeType === 'makeI'">
                  <div class="form-field">
                    <label>5.3.1 Last Purchase Price(in INR)</label>
                    <input pInputText formControlName="llp" [readonly]="true" class="readonly-input" />
                  </div>
                  <div class="form-field">
                    <label>5.3.2 Last Purchase Year</label>
                    <p-calendar formControlName="lpyear" view="year" dateFormat="yy" [disabled]="true"></p-calendar>
                  </div>
                  <div class="form-field">
                    <label>5.3.3 Savings To Exchequer</label>
                    <input pInputText formControlName="exchequer" [readonly]="true" class="readonly-input" />
                  </div>
                  <div class="form-field">
                    <label>5.3.4 POEV</label>
                    <input pInputText formControlName="poev" [readonly]="true" class="readonly-input" />
                  </div>
                </ng-container>
                <!-- Make II/III: LPP / Similar Development -->
                <div class="form-field" *ngIf="schemeType === 'makeII' || stepDetails?.step_mapping?.scheme?.code === 'makeiii'">
                  <label>LPP / Similar Development</label>
                  <input pInputText formControlName="llp" [readonly]="true" class="readonly-input" />
                </div>
                <!-- Rev: LLP and LP Year -->
                <div class="form-field" *ngIf="schemeType === 'rev'">
                  <label>Last Purchase Price(in INR)</label>
                  <input pInputText formControlName="llp" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field" *ngIf="schemeType === 'rev'">
                  <label>Last Purchase Year</label>
                  <p-calendar formControlName="lpyear" view="year" dateFormat="yy" [disabled]="true"></p-calendar>
                </div>
                <div class="form-field" *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
                  <label>POEV Cost</label>
                  <input pInputText formControlName="poev" [readonly]="true" class="readonly-input" />
                </div>
                <div class="form-field" *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
                  <label>Consignee</label>
                  <input pInputText formControlName="consignee" [readonly]="true" class="readonly-input" />
                </div>
              </div>
            </div>
          </div>

          <!-- Detailed Information Section (Rev only) -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="schemeType === 'rev'">
            <div (click)="expandedSections['detailedInfo'] = !expandedSections['detailedInfo']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-file"></i>
                </span>
                Detailed Information
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['detailedInfo']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">Brief Description/Technical Details</p>
                <editor [init]="previousInit" formControlName="technical_details" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">Justification for mode of tender</p>
                <editor [init]="previousInit" formControlName="justificationText" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">Any export potential of the proposed item</p>
                <editor [init]="previousInit" formControlName="exportPotential" [disabled]="true"></editor>
              </div>
            </div>
          </div>

          <!-- === Make Scheme Justification Section === -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="isMakeScheme">
            <div (click)="expandedSections['justification'] = !expandedSections['justification']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-check-square"></i>
                </span>
                {{ schemeType === 'makeI' ? '6. Justification To Progress The Case Under Make 1 Category' :
                   (stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5. Justification To Progress The Case Under Make 3 Category' :
                   '5. Justification To Progress The Case Under Make 2 Category') }}
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['justification'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['justification']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5.1 Item already held in Inventory requiring Import substitution.' : (schemeType === 'makeI' ? '6.1 Advantage of availability of technology indigenously designed product' : '5.1 Advantage of availability of technology indigenously designed product') }}
                </p>
                <editor [init]="previousInit" formControlName="indigenously_designed" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'Make II' && schemeType !== 'makeII'">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5.2. Cost Effectiveness' : '6.2 Availability of design capability and infrastructure in India' }}
                </p>
                <editor [init]="previousInit" formControlName="capability_infrastructure" [disabled]="true"></editor>
              </div>
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'Make II' && schemeType !== 'makeII'">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5.3 Lead time' : '6.3 Is the proposed system a part of Long Term Perspective Plan(LTPP)' }}
                </p>
                <editor [init]="previousInit" formControlName="ltpp" [disabled]="true"></editor>
              </div>
            </div>
          </div>

          <!-- === Make Scheme Detailed Fields === -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md" *ngIf="isMakeScheme">
            <div (click)="expandedSections['makeDetailedFields'] = !expandedSections['makeDetailedFields']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-list"></i>
                </span>
                Make Scheme Details ({{ schemeType === 'makeI' ? '7-23' : (stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '6-20' : '6-20') }})
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['makeDetailedFields'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div *ngIf="expandedSections['makeDetailedFields']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">

              <!-- Lead Development / Vintage & OEM -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ schemeType === 'makeI' ? '7' : '6' }}. {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? 'Vintage and OEM' : 'Expected Lead Time for Prototype Development' }}
                </p>
                <!-- <editor [init]="previousInit" formControlName="lead_development" [disabled]="true"></editor> -->
                 <editor
    [init]="previousInit"
    [id]="stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? 'vinatge_oem' : 'lead_development'"
    [formControlName]="stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? 'vinatge_oem' : 'lead_development'"
  >
  </editor>
              </div>

              <!-- Indigenise Equipment (Make I/II) -->
              <div *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'makeiii'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">
                    {{ schemeType === 'makeII' ? '7' : '8' }}. Requirement to indigenise the proposed equipment (Details of vintage and OEM)
                  </p>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">
                    {{ schemeType === 'makeII' ? '7.1' : '8.1' }} In view of obsolescence/ upgradation/ replacement/ import substitution / new induction to counter emerging threat perception
                  </p>
                  <editor [init]="previousInit" formControlName="indigenise_equipment" [disabled]="true"></editor>
                </div>
              </div>

              <!-- Indigenise Equipment (Make III) -->
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="stepDetails?.step_mapping?.scheme?.code === 'makeiii'">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  7. Requirement of indigenizing existing equipment view obsolescence or upgradation or replacement
                </p>
                <editor [init]="previousInit" formControlName="indigenise_equipment" [disabled]="true"></editor>
              </div>

              <!-- RFI / Market Survey -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '8. Details of RFI/Market survey undertaken with date and responses therein'
                    : (schemeType === 'makeII'
                      ? '8. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms) / Details of any collaboration with foreign OEM envisaged'
                      : '9. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms)') }}
                </p>
                <editor [init]="previousInit" formControlName="rfi_indigenous" [disabled]="true"></editor>
              </div>

              <!-- Manufacture (Make III only - 9) -->
              <ng-container *ngIf="stepDetails?.step_mapping?.scheme?.code === 'makeiii'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">
                    9. Proposed to manufacture in India through which firms (with details)/franchises of OEM/Details of market survey undertaken
                  </p>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">
                    9.1. Confirmation from at least one known MSME or vendor that the equipment/system can be developed and manufactured in India as per design of OEM with minimum 60% Indigenous Content
                  </p>
                  <editor [init]="previousInit" formControlName="collaboration_envisaged" [disabled]="true"></editor>
                </div>
              </ng-container>

              <!-- Collaboration with foreign partner (Make I, not Make II/III) -->
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="schemeType !== 'makeII' && stepDetails?.step_mapping?.scheme?.code !== 'makeiii'">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  10. Details of any collaboration envisaged with foreign partner (If yes, details to be provided)
                </p>
                <editor [init]="previousInit" formControlName="collaboration_envisaged" [disabled]="true"></editor>
              </div>

              <!-- DRDO/PSU -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '10. Confirmation of at least one Indian Entity/firm ready to undertake JV/ToT with Foreign OEM'
                    : (schemeType === 'makeII'
                      ? '9. Confirmation that indigenisation is not being undertaken through DRDO/PSU'
                      : '11. Confirmation that indigenisation is not being undertaken through DRDO/PSU or IA/IAF (If indigenisation has been attempted previously then the bottleneck that the present proposal aims to overcome)') }}
                </p>
                <editor [init]="previousInit" formControlName="drdo_psu" [disabled]="true"></editor>
              </div>

              <!-- Technical Specifications -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '11. Details of technical specifications of the equipment/ system/ spare'
                    : (schemeType === 'makeII'
                      ? '10. Details of technical specifications of the equipment/system / Role of the proposed item/ system in overall operational strategy'
                      : '12. Details of technical specifications of the equipment/system') }}
                </p>
                <editor [init]="previousInit" formControlName="technical_specifications" [disabled]="true"></editor>
              </div>

              <!-- Operational Requirements -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '12. Details of operational requirements of the equipment/system/spare'
                    : (schemeType === 'makeII'
                      ? '11. Details of operational requirements of the equipment'
                      : '13. Details of operational requirements of the equipment / Role of proposed item in overall operation strategy') }}
                </p>
                <editor [init]="previousInit" formControlName="operationalRequirements" [disabled]="true"></editor>
              </div>

              <!-- Drawings/Manuals -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '13' : (schemeType === 'makeII' ? '12' : '14') }}. Availability of drawings/manuals/technical documentation
                </p>
                <editor [init]="previousInit" formControlName="drawings_manuals" [disabled]="true"></editor>
              </div>

              <!-- Sample Indigenisation -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '14' : (schemeType === 'makeII' ? '13' : '15') }}. Availability of sample for indigenisation (if required)
                </p>
                <editor [init]="previousInit" formControlName="sample_indigenisation" [disabled]="true"></editor>
              </div>

              <!-- Annual Acquisition -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '15. Confirmation if project is included in Annual Acquisition Plan'
                    : (schemeType === 'makeII'
                      ? '14. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan'
                      : '16. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan') }}
                </p>
                <editor [init]="previousInit" formControlName="annual_Acquisition" [disabled]="true"></editor>
              </div>

              <!-- Trials & Environments -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '16' : (schemeType === 'makeII' ? '15' : '17') }}. List and venue of likely trials and environmental tests / Type IAW MIL or other standards
                </p>
                <editor [init]="previousInit" formControlName="trials_environments" [disabled]="true"></editor>
              </div>

              <!-- Photograph of Item -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '17' : (schemeType === 'makeII' ? '16' : '18') }}. Availability of photograph of item
                </p>
                <editor [init]="previousInit" formControlName="photograph_item" [disabled]="true"></editor>
              </div>

              <!-- Export Potential (Make I only, NOT makeII or makeIII) -->
              <div class="editor-field" [class.readonly-editor]="true" *ngIf="schemeType === 'makeI'">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  19. Any envisaged export potential of the equipment/system (For viability of the proposal to be taken under Make I category)
                </p>
                <editor [init]="previousInit" formControlName="export_potential" [disabled]="true"></editor>
              </div>

              <!-- Draft Project Report / Feasibility (Make I only, NOT makeII or makeIII) -->
              <ng-container *ngIf="schemeType === 'makeI'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20. Draft Project Report/Feasibility Report</p>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20.1 Description of critical technology required</p>
                  <editor [init]="previousInit" formControlName="critical_technology" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20.2 Infrastructure required/Available with DRDO/Services/PSU</p>
                  <editor [init]="previousInit" formControlName="drdo_infrastructure" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20.3 Infrastructure required for trials</p>
                  <editor [init]="previousInit" formControlName="trial_infrastructure" [disabled]="true"></editor>
                </div>
              </ng-container>

              <!-- Project Similar -->
              <div class="editor-field" [class.readonly-editor]="true">
                <p class="bg-blue-500 p-2 text-white font-medium">
                  {{ stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '18. Confirmation that the indigenization is not being undertaken through DRDO/PSU'
                    : (schemeType === 'makeII'
                      ? '17. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.'
                      : '21. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.') }}
                </p>
                <editor [init]="previousInit" formControlName="project_similar" [disabled]="true"></editor>
              </div>

              <!-- Approval APSO & Nodal Officer (Make I only, NOT makeII or makeIII) -->
              <ng-container *ngIf="schemeType === 'makeI'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">22. Approval and priority from APSO concerned for case under Make I category</p>
                  <editor [init]="previousInit" formControlName="approval_apso" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">23. Details of nodal officer execute the project through the Capital Route under MAKE I category from user Dte.</p>
                  <editor [init]="previousInit" formControlName="nodal_officer_details" [disabled]="true"></editor>
                </div>
              </ng-container>

              <!-- MakeIII-specific: Confirmation indigenisation not through DRDO/PSU (already shown at section 18 via project_similar above) -->
              <!-- MakeIII does NOT have sections 19-23; it ends at section 18 -->


              <!-- Nodal Officer, APSO, Revenue/iDEX (Make II) -->
              <ng-container *ngIf="schemeType === 'makeII' &&  stepDetails?.step_mapping?.scheme?.code !== 'makeiii'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">18. Details of nodal officer execute the project through the Capital Route under MAKE II category from user Dte.</p>
                  <editor [init]="previousInit" formControlName="nodal_officer_details" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">19. Approval and priority from APSO concerned for case to be fielded under MAKE II Category</p>
                  <editor [init]="previousInit" formControlName="approval_apso" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20. Is Item under Revenue/iDEX procurement?</p>
                  <editor [init]="previousInit" formControlName="critical_technology" [disabled]="true"></editor>
                </div>
              </ng-container>

              <!-- 19 & 20 for makeIII -->
              <ng-container *ngIf="stepDetails?.step_mapping?.scheme?.code === 'makeiii'">
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">19. Details of nodal officer execute the project through the Capital Route under MAKE III category from user Dte.</p>
                  <editor [init]="previousInit" formControlName="nodal_officer_details" [disabled]="true"></editor>
                </div>
                <div class="editor-field" [class.readonly-editor]="true">
                  <p class="bg-blue-500 p-2 text-white font-medium">20. Approval and priority from APSO concerned for each of the cases to be fielded under Make III category</p>
                  <editor [init]="previousInit" formControlName="approval_apso" [disabled]="true"></editor>
                </div>
              </ng-container>

            </div>
          </div>

          <!-- Document Upload Section -->
          <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
            <div (click)="expandedSections['needGenUploads'] = !expandedSections['needGenUploads']"
                 class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
              <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                  <i class="pi pi-upload"></i>
                </span>
                Document Uploads
              </h3>
              <i class="pi transition-transform duration-200"
                 [ngClass]="expandedSections['needGenUploads'] ? 'pi-chevron-down' : 'pi-chevron-right'">
              </i>
            </div>
            <div *ngIf="expandedSections['needGenUploads']" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
              <app-upload-document 
                [isEditable]="false" 
                [dmsFiles]="needGenDmsFiles"
                [proposal_step]="needGenProposalStep">
              </app-upload-document>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="proposal-form-container">
    <div class="form-container">
      <!-- === File Upload Section === -->
      <div class="form-section">
        <div class="section-header" (click)="toggleSection('uploads')">
          <h3 class="section-title">
            Document Uploads
            <i class="pi" [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>

        <!-- File Uploads Section -->
        <div class="section-content" *ngIf="expandedSections['uploads']">
          <div class="form-section">
            <!-- <h3 class="section-title">Document Uploads</h3> -->
            <!-- Document Upload Table -->
            <!-- <app-upload-document (uploadData)="onDocumentUpload($event)" [isEditable]="stepDetails?.can_edit" [dmsFiles]="allDmsFiles"
              (documentEdited)="onDocumentEdited($event)" (documentDeleted)="onDocumentDeleted($event)">
            </app-upload-document> -->
            <!-- <app-upload-document [isEditable]="stepDetails?.can_edit" [id]="id"></app-upload-document> -->
             <app-upload-document [isEditable]="stepDetails?.can_edit"></app-upload-document>
            <!-- 🔹 Upload Progress Indicator -->
            <div class="mt-3" *ngIf="uploadProgress > 0">
              <div class="progress" style="height: 10px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                  [style.width.%]="uploadProgress">
                  {{ uploadProgress }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Remarks Section -->
  <div class="row mt-4">
    <div class="col-4 bg-primary text-white d-flex align-items-center">
      <b class="fw-semibold mb-0 text-white">Remarks  </b>
    </div>
    <div class="col-8">
      <textarea id="remarks" class="form-control" [(ngModel)]="remark" rows="4" placeholder="Enter any remarks..." [disabled]="isEditorDisabled"></textarea>
    </div>
  </div>
</div>



